import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as MuiCheckbox, Tooltip } from '@mui/material';
import { Text } from './Text';
import { StyledSelectionWrapper } from './Checkbox.styles';

export const Checkbox = ({ label, table, cell, title, Component = Text }) => {
  if (!cell && (!label || typeof label !== 'string')) {
    console.error('`label` need to be passed as string in `Header` definition');
    return null;
  }

  if (!table && !cell) {
    console.error(
      '`table` or `cell` need to be passed depends where select checkbox need to be rendered',
    );
    return null;
  }

  const { indeterminate, ...rest } = table
    ? table.getToggleAllPageRowsSelectedProps()
    : cell.row.getToggleRowSelectedProps();

  const value = table ? label : cell;

  return (
    <StyledSelectionWrapper
      isHeader={!!table}
      onClick={(e) => e.stopPropagation()}
    >
      <Tooltip
        title={title}
        placement="bottom-start"
        PopperProps={{
          sx: {
            '& .MuiTooltip-tooltip': {
              whiteSpace: 'nowrap',
              padding: '10px',
            },
          },
        }}
      >
        <MuiCheckbox
          sx={{
            padding: '6px',
          }}
          {...rest}
          title=""
        />
      </Tooltip>
      {Component(value)}
    </StyledSelectionWrapper>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  table: PropTypes.object,
  cell: PropTypes.object,
  Component: PropTypes.node,
  title: PropTypes.string,
};
